export enum CommunicationType {
  SMS = 'SMS',
  Email = 'Email',
  CallsAndComments = 'CallsAndComments',
  Banks = 'Banks',
}

export interface ICommunication {
  selectedCommunicationType: CommunicationType;
}
